import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchCurrencies } from '../ActionCreators';

interface ICurrenciesState {
	currencies: string[];
	isLoading: boolean;
	error: string;
}
const initialState: ICurrenciesState = {
	currencies: [],
	isLoading: false,
	error: null,
};

export const currenciesSlice = createSlice({
	name: 'currencies',
	initialState,
	reducers: {},
	extraReducers: {
		[fetchCurrencies.fulfilled.type]: (state, action: PayloadAction<string[]>) => {
			state.isLoading = false;
			state.error = null;
			state.currencies = action.payload;
		},
		[fetchCurrencies.pending.type]: (state) => {
			state.isLoading = true;
		},
		[fetchCurrencies.rejected.type]: (state, action: PayloadAction<string>) => {
			state.isLoading = false;
			state.error = action.payload;
		}
	},
});

export default currenciesSlice.reducer;
